<script setup>
import { footerColumns } from '@/views/home/components/guestHomeData.js'

const props = defineProps({
  isShow: {
    type: Boolean,
    default: true,
  },
  minFooter: {
    type: Boolean,
    default: false,
  },
})

const homeBanner = new URL('/public/image/qr.webp', import.meta.url)
</script>

<template>
  <Communication v-if="isShow" :minFooter="minFooter" />

  <div :class="['footer', minFooter && 'min-footer']">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img
            class="mb2"
            src="https://www.quectel.com.cn/wp-content/themes/quectel-cn/images/svg/q_white.svg"
            alt="Quectel"
            width="32px"
            height="22px"
            loading="lazy"
          />
        </div>
        <div class="col" v-for="column in footerColumns" :key="column.title">
          <span class="fs-18">{{ column.title }}</span>
          <ul class="list">
            <li
              class="group-list"
              v-for="item in column.links"
              :key="item.name"
            >
              <a
                v-if="item.link"
                class="transition hover-txt-active"
                :href="item.link"
                :target="item.target"
                :rel="
                  item.target === '_blank' ? 'noopener noreferrer' : undefined
                "
                v-track="{ position: 'footer > link', name: item.name }"
                >{{ item.name }}</a
              >
              <span v-else class="footer-item-text">{{ item.name }}</span>
            </li>
          </ul>
        </div>

        <div class="col ms-auto">
          <span class="fs-18">联系我们</span>
          <ul class="list">
            <li class="text-nowrap">全国热线：400 960 7678</li>
            <li class="text">全球中心：上海市松江区泗泾镇外婆泾路8号</li>
            <li class="text-nowrap">
              <img
                :src="homeBanner"
                loading="lazy"
                width="120"
                height="120"
                class="q-wechat"
                alt="二维码"
              />
              <span class="fs-12"> 微信公众号：移远通信 </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="pt-4">
        <div class="g-4">
          <div class="col-12 col-sm-auto">
            <div class="d-flex">
              <a
                class="transition"
                href="https://www.quectel.com.cn/cookies-policy"
                target="_blank"
                rel="noopener noreferrer"
                >Cookie政策</a
              >
              <span class="mx-2">|</span>
              <a
                class="transition"
                href="https://www.quectel.com.cn/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                >隐私协议</a
              >
              <span class="mx-2">|</span>
              <a
                class="transition"
                href="https://www.quectel.com.cn/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
                >服务协议</a
              >
            </div>
          </div>
          <div class="col-12 col-sm-auto ms-sm-auto">
            <div class="footer-filing">
              <a
                class="beian_mps transition"
                href="https://beian.mps.gov.cn/#/query/webSearch?code=31011702889058"
                target="_blank"
                rel="noopener noreferrer"
                >沪公网安备31011702889058</a
              >
              <a
                class="transition fs-14"
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
                >沪ICP备18027903号-9</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
li {
  list-style: none;
}
.mb2 {
  margin-bottom: 0.5rem !important;
}
.ml10 {
  margin-left: 10px;
}
.min-footer {
  min-width: 1270px;
  width: 100%;
}
a,
a:active,
a:hover,
a:visited,
a:link {
  text-decoration: none;
  color: #fff;
}
.ms-auto {
  margin-left: auto;
  .text-nowrap {
    margin-bottom: 1.5rem;
    white-space: nowrap;
    color: #a7a0a0;
    .q-wechat {
      width: 120px;
      max-width: 100%;
      display: block;
    }
    .fs-12 {
      font-size: 12px;
      margin-top: 0.5rem;
      display: inline-block;
      line-height: 1.25;
    }
  }

  .text {
    margin-bottom: 1.5rem;
    color: #a7a0a0;
  }
}

@media (min-width: 992px) {
  .footer .container {
    max-width: 960px !important;
  }
}
@media (min-width: 1200px) {
  .footer .container {
    max-width: 1140px !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
}
@media (min-width: 1400px) {
  .footer .container {
    max-width: 1320px !important;
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
}

@media (min-width: 1500px) {
  .footer .container {
    max-width: 1448px !important;
  }
}

.footer {
  background-color: #000;
  overflow: hidden;
  color: #fff;
  padding-top: 3rem;
  padding-bottom: 3rem;
  flex-shrink: 0;
  box-sizing: border-box;
}

.container {
  --bs-gutter-x: 3rem;
  --bs-gutter-y: 0;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: calc(3rem * 0.5);
  padding-left: calc(3rem * 0.5);
  box-sizing: border-box;

  .row {
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin-top: calc(-1 * 1.5rem);
    margin-right: calc(-0.5 * 1.5rem);
    margin-left: calc(-0.5 * 1.5rem);
    --bs-gutter-y: 1.5rem;
    --bs-gutter-x: 1.5rem;
    & > * {
      width: 100%;
      max-width: 100%;
      padding-right: calc(1.5rem * 0.5);
      padding-left: calc(1.5rem * 0.5);
      margin-top: 1.5rem;
      box-sizing: border-box;
    }

    .col-12 {
      flex: 0 0 auto;
      width: 100%;
      box-sizing: border-box;
    }

    .col {
      flex: 1 0 0%;
      padding: 0 12px;
      .fs-18 {
        font-size: 18px;
      }
    }

    .list {
      list-style: none;
      padding: 0;
      font-size: 14px;
      margin-top: 1.5rem;

      .group-list {
        line-height: 1.25;
        min-width: 85px;
        margin-bottom: 1.5rem;
        a,
        .footer-item-text {
          color: #a7a0a0;
          text-decoration: none;
        }
        a:hover {
          color: #ed000c;
        }
      }
    }
  }

  .pt-4 {
    padding-top: 3rem;
    .g-4 {
      align-items: flex-end;
      display: flex;
      flex-wrap: wrap;
      .col-12 {
        flex: 0 0 auto;
        width: 100%;
        .d-flex {
          font-size: 16px;
          align-items: center;
          flex-wrap: wrap;
          display: flex;
          color: rgba(255, 255, 255, 1);
          .mx-2 {
            margin-left: 0.5rem;
            margin-right: 0.5rem;
          }
          .transition {
            cursor: pointer;
            &:hover {
              color: #ed000c;
            }
          }
        }
      }
      @media (min-width: 576px) {
        .col-sm-auto {
          flex: 0 0 auto;
          width: auto;
        }
      }
      @media (min-width: 576px) {
        .ms-sm-auto {
          margin-left: auto !important;
        }
      }

      .footer-filing {
        align-items: center;
        flex-wrap: wrap;
        display: inline-flex;
        .beian_mps {
          padding-left: 24px;
          background: url('/public/new-image/gaba.png') no-repeat left center /
            contain;
          text-decoration: none;
          font-size: 14px;
          margin-right: 1rem;
          color: #fff;
        }

        .transition {
          cursor: pointer;
          &:hover {
            color: #ed000c;
          }
        }

        .fs-14 {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
